export const PTB_CARD_ANCHOR_VIEWPORT_PADDING = 8;
export const PTB_CARD_ANCHOR_GAP = 8;
export const PTB_CARD_ANCHOR_Z_INDEX = 121;

export function getCardElement(cardId) {
  if (!cardId) {
    return null;
  }

  return document.querySelector(
    `[data-appointment-id="${CSS.escape(String(cardId))}"]`,
  );
}

export function computeCardAnchoredPosition(
  anchorRect,
  contentRect,
  { horizontalAlign = 'center', preferredPlacement = 'above' } = {},
) {
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const contentWidth = contentRect.width;
  const contentHeight = contentRect.height;

  const aboveTop = anchorRect.top - PTB_CARD_ANCHOR_GAP - contentHeight;
  const belowTop = anchorRect.bottom + PTB_CARD_ANCHOR_GAP;
  const preferBelow = preferredPlacement === 'below';

  let placement = preferBelow ? 'below' : 'above';
  let top = preferBelow ? belowTop : aboveTop;

  if (preferBelow) {
    if (
      top + contentHeight >
      viewportHeight - PTB_CARD_ANCHOR_VIEWPORT_PADDING
    ) {
      if (aboveTop >= PTB_CARD_ANCHOR_VIEWPORT_PADDING) {
        placement = 'above';
        top = aboveTop;
      } else {
        top = Math.max(
          PTB_CARD_ANCHOR_VIEWPORT_PADDING,
          Math.min(
            top,
            viewportHeight - PTB_CARD_ANCHOR_VIEWPORT_PADDING - contentHeight,
          ),
        );
      }
    }
  } else if (top < PTB_CARD_ANCHOR_VIEWPORT_PADDING) {
    placement = 'below';
    top = belowTop;

    if (
      top + contentHeight >
      viewportHeight - PTB_CARD_ANCHOR_VIEWPORT_PADDING
    ) {
      if (aboveTop >= PTB_CARD_ANCHOR_VIEWPORT_PADDING) {
        placement = 'above';
        top = aboveTop;
      } else {
        top = Math.max(
          PTB_CARD_ANCHOR_VIEWPORT_PADDING,
          Math.min(
            top,
            viewportHeight - PTB_CARD_ANCHOR_VIEWPORT_PADDING - contentHeight,
          ),
        );
      }
    }
  }

  if (placement === 'above') {
    top = Math.max(PTB_CARD_ANCHOR_VIEWPORT_PADDING, top);
  }

  let left =
    horizontalAlign === 'left'
      ? anchorRect.left
      : anchorRect.left + anchorRect.width / 2 - contentWidth / 2;
  left = Math.max(
    PTB_CARD_ANCHOR_VIEWPORT_PADDING,
    Math.min(
      left,
      viewportWidth - PTB_CARD_ANCHOR_VIEWPORT_PADDING - contentWidth,
    ),
  );

  const cardCenterX = anchorRect.left + anchorRect.width / 2;
  const naturalCaretLeft = cardCenterX - left;
  const caretLeft =
    preferBelow && placement === 'below'
      ? contentWidth - naturalCaretLeft
      : naturalCaretLeft;

  return {
    top,
    left,
    placement,
    caretLeft,
  };
}
